<template>
  <div class="index-box">
    <div class="info-box">
      <div class="index-notice-detail">
        <h2 class="detail-title">{{name}}</h2>
        <div class="detail-info-h5" v-html="content">


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "indexDetail",
    data() {
      return {
        name: '',
        id: '',
        content:''
      }
    },
    created() {

      this.name = this.$route.query.name
      this.id = this.$route.query.id
      this.init()
    },
    methods: {
      init() {
        this.$api.apiContent.instruction({
          token: this.$store.state.user.token,
          type: this.id,
        }).then(res => {
          this.content = res.row.content
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .index-box {
    .page-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 46px;
      padding: 0 24px;
      background-color: #ffffff;
      a{
        display: block;
        width: 102px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        color: #2b8ee3;
        background-color: #e9f5ff;
        border-radius: 13px;
      }
    }

    .info-box {
      padding: 20px;
      background: #fff;

      .index-notice-detail{
        .detail-title{
          text-align: center;
          font-size: 20px;
          line-height: 36px;
          color: #333333;
          margin-bottom: 20px;
        }
        .detail-time{
          text-align: center;
          font-size: 16px;
          color: #666;
          margin-bottom: 20px;
        }
        .detail-info{
          line-height: 150%;
          text-indent: 24px;
        }
      }
    }
  }
</style>